import { useState } from 'react';
import useToast from 'components/hooks/useToast';
import { ERROR_TYPES, ValidationError } from 'common/constants/error-types';
import { IDENTITY_PROVIDERS } from 'common/constants/constants';
import { ORG_DETECTION_STRATEGY } from './useFormState/formState.types';

const useFormSaveHandler = ({
  formState,
  integration,
  integrationDiscoverySetting
}) => {
  const toast = useToast();
  const [isLoading, setIsLoading] = useState(false);
  const sensorName = integration?.sensor_name;

  const validateRegex = regexStr => {
    try {
      new RegExp(regexStr);
      return true;
    } catch (e) {
      return false;
    }
  };

  const validateForm = async () => {
    if (!validateRegex(formState.inclusionRegex))
      throw new ValidationError(
        'Inclusion - Given pattern is an invalid regex'
      );
    if (!validateRegex(formState.exclusionRegex))
      throw new ValidationError(
        'Exclusion - Given pattern is an invalid regex'
      );
    if (formState.visibility.length === 0)
      throw new ValidationError('Please choose at least 1 visbility option');

    if (formState.orgDetectionStrategy === ORG_DETECTION_STRATEGY.REGEX) {
      if (
        formState.orgDetectionStrategyRegex.length === 0 ||
        !validateRegex(formState.orgDetectionStrategyRegex)
      )
        throw new ValidationError('Organizations selection regex is invalid');
    } else if (
      formState.orgDetectionStrategy === ORG_DETECTION_STRATEGY.ORG_SELECTION
    ) {
      if (
        sensorName === IDENTITY_PROVIDERS.GITHUB &&
        formState.selectedGithubOrgs.length === 0
      )
        throw new ValidationError(
          'Please choose at least 1 Github organization'
        );
    }
  };

  const onSave = async () => {
    try {
      setIsLoading(true);
      await validateForm();
      await integrationDiscoverySetting.upsert(formState.newSettingPayload);
      toast({ message: 'Monitring rules saved successfully' });
      return true;
    } catch (e) {
      let errMessage;
      switch (e.type) {
        case ERROR_TYPES.VALIDATION_ERROR:
          errMessage = e.message;
          break;
        default:
          errMessage = 'ooops.. something went wrong.';
      }
      toast({ variant: 'error', message: errMessage });
      return false;
    } finally {
      setIsLoading(false);
    }
  };

  return {
    onSave,
    isLoading
  };
};

export default useFormSaveHandler;
